import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { getUserTokenById } from "../../services/apis/user";
import jwtDecode from "jwt-decode";
import { postList } from "../../api/apiDataExchange";
import { storeConfig } from "../../hooks/config";
import LoaderComponent from '../loaderCompent/LoaderComponent'

const isMongoId = (str) => {
    if (!str) {
        return false;
    }
    if (str.length !== 24) {
        return false;
    }
    const hexRegex = /^[0-9a-fA-F]{24}$/;
    return hexRegex.test(str);
};

export default function AutoLogin() {
    // AutoLogin with Id changes start
    const location = useLocation();
    const { logout } = useAuth();
    const navigate = useNavigate();

    const loginByID = async () => {
        const queryParams = new URLSearchParams(location.search);
        var userid = queryParams.get("userid");
        if (!userid) {
            userid = await localStorage.getItem("userId");
        }

        if (isMongoId(userid)) {
            localStorage.clear();
            // logout()
            setTimeout(async () => {
                const user = await getUserTokenById(userid)
                if (user.success) {
                    const token = user?.result?.token;
                    let decodedToken = null;
                    if (token) {
                        decodedToken = jwtDecode(token);
                        localStorage.setItem("userId", decodedToken?._id);
                        localStorage.setItem("isOtpVerified", decodedToken?.isOtpVerified);
                        const orgData = await postList(`${process.env.REACT_APP_API_URL}/organisation/list`)
                        if (orgData?.data?.results?.length > 0) {
                            navigate('/dashboard');
                        } else {
                            navigate('/my-data');
                        }
                        const config = JSON.parse(localStorage.getItem('config'));
                        if (!config) {
                            await storeConfig();
                        }
                    }
                }

                window.location.reload();
            }, 2000);
        }
        else {
            localStorage.clear();
            logout()
            setTimeout(() => {
                navigate('/login');
            }, 1000);
        }
    }

    useEffect(() => {
        loginByID();
    }, []);

    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <LoaderComponent />
        </div>
    );
}
